import { formatNum, getIsErrorValue } from "@/pages/dashboard/utils/utils";

export const formatMarketValue = (commonValue: Array<string> = [], selectValue: Array<string>) => {
  // 公共国家筛选器 折扣图国家筛选器 交集结果
  // ['255'] ∩ ['255'] = ['255']
  // ['255'] ∩ ['us']  = ['us']
  // ['us'] ∩ ['255'] = ['us']
  // ['us','uk'] ∩ ['uk'] = ['uk']
  // ['us'] ∩ ['us','uk'] = ['us']
  // ['uk'] ∩ ['us'] = []
  if (commonValue?.includes('255') && selectValue?.includes('255')) {
    return commonValue;
  }
  if (commonValue?.includes('255') && !selectValue?.includes('255')) {
    return selectValue;
  }
  if (!commonValue?.includes('255') && selectValue?.includes('255')) {
    return commonValue;
  }
  if (!commonValue?.includes('255') && !selectValue?.includes('255')) {
    return selectValue.filter((val) => commonValue.indexOf(val) > -1);
  }
};

const margin = {
  left: 60,
  right: 40,
};

const formatGird = (opt: any, legend: any[]) => {
  const newGird = [{ top: 20 }, ...legend]?.map((item, index) => {
    if (index === 0) return {
      top: 20,
      height: 275,
      ...margin,
    };
    return {
      top: 275 + 20 + 110 * index + (opt?.extraTop || 0),
      height: 60,
      ...margin,
      tooltip: {
        show: true,
        formatter: null,
      }
    };
  });
  // eslint-disable-next-line no-param-reassign
  opt.legend.top = 330;
  // eslint-disable-next-line no-param-reassign
  opt.grid = newGird;
  return opt;
};

const formatXAxis = (opt: any, legend: any[], hasDiscond = true) => {
  const newxAxis = (hasDiscond ? legend : [])?.map((v, index) => ({
    ...opt?.xAxis?.[1],
    gridIndex: index + 1,
  }));
  // eslint-disable-next-line no-param-reassign
  opt.xAxis = [opt?.xAxis?.[0], ...newxAxis];
  return opt;
};

export const salesOverviewFormatOption = (opt: any, legend: any[], hasDiscond = true) => {
  // eslint-disable-next-line no-param-reassign
  opt = formatGird(opt, legend);
  // eslint-disable-next-line no-param-reassign
  opt = formatXAxis(opt, legend, hasDiscond);
  return opt;
};

export const salesOverviewPaddingMap: any = {
  Playstation: -27,
  Steam: 5,
  Epic: 12,
  Nintendo: -14,
  XBox: 12
};

export const getSumValue = (arr: any[] = [], isUserType?: boolean) => {
  const isNull = arr?.every(item => item?.value === '');
  if (isNull) return '-';
  const sumValue = arr?.reduce((pre, cur) => {
    // eslint-disable-next-line no-param-reassign
    if (!isNaN(parseFloat(cur.value))) pre += parseFloat(cur.value);
    return pre;
  }, 0);
  return formatNum(sumValue, false, isUserType);
};


export const newFormatPercentNum = (num: number, fixedNumber = 2, isFloating = false, isBigPercent = false) => {
  if (getIsErrorValue(num)) return '-';
  if (isNaN(num)) return num;

  let newFixedNumber = fixedNumber;
  // Ensure fixedNumber is within the range of 0 to 4
  if (fixedNumber < 0 || fixedNumber > 4 || !Number.isInteger(fixedNumber)) newFixedNumber = 2;

  // If it's a price change, keep one decimal place
  if (isFloating) newFixedNumber = 1;
  // Take the absolute value, as negative numbers might be passed in
  const number = Math.abs(num);
  const prefix = num < 0 ? '-' : '';
  // Use exponentiation operator (**) instead of Math.pow
  const fixedPow = 100 * 10 ** newFixedNumber;
  const floatPow = 10 ** newFixedNumber;
  const percentage = (Math.round(number * fixedPow) / floatPow).toFixed(newFixedNumber);

  // Display 0% if it's a zero change
  if (isFloating && Number(percentage) === 0) return '0%';

  if (isBigPercent) {
    return parseFloat(percentage) > 9999.99 ? `${prefix}9999.99%+` : `${prefix + percentage}%`;
  }
  return parseFloat(percentage) > 999.9 ? `${prefix}999.9%+` : `${prefix + percentage}%`;
};

export const replacePlaceholders = (str: string, placeholders: any) => {
  const appendedValues: string[] = [];
  const replacedString = str.replace(/{{(.*?)}}/g, (match: string, p1: string) => {
    let value: any = placeholders[p1] || match;
    if (value.includes('($)')) {
      const dollarIndex = value.indexOf('($)');
      const appendedValue = value.slice(dollarIndex);
      value = value.slice(0, dollarIndex);
      appendedValues.push(appendedValue);
    }
    return value;
  });

  if (appendedValues.length > 0) {
    return `${replacedString}${appendedValues.join('')}`;
  }

  return replacedString;
};